module.exports = __webpack_public_path__ + "static/media/Brushaff.8fa72fac.otf";